// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/31835
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 31835 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
interface IExpoTrackParamsRecord {
  /** ochama after-sale entry */
Ochama_Aftersale_Entry_Exp: undefined
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** ochama after-sale entry */
  Ochama_Aftersale_Entry_Exp:'Ochama_Aftersale_Entry_Exp',
})

interface IClickTrackParamsRecord {
  /** ochama after-sale entry */
Ochama_Aftersale_Entry_Click: undefined
}

const sendClickTrack = {
  /** 点击事件上报-ochama after-sale entry */
Ochama_Aftersale_Entry_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Ochama_Aftersale_Entry_Click'});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
}
export type {
  IExpoTrackParamsRecord,
}